import { render, staticRenderFns } from "./secondary_education.vue?vue&type=template&id=44d3239e&"
import script from "./secondary_education.vue?vue&type=script&lang=js&"
export * from "./secondary_education.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports